import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../context/I18nContext';
import PostCard from '../components/PostCard';
import BottomNav from '../components/BottomNav';
import { formatAura } from '../lib/aura';

export default function HashtagPage() {
  const { tag } = useParams();
  const nav = useNavigate();
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/hashtags/${tag}/posts`);
        setItems(data.items || []);
      } catch (_e) { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, [tag]);

  return (
    <div className="min-h-screen bg-aura-bg pb-28 relative">
      <div className="absolute inset-0 bg-aura-radial pointer-events-none" />
      <header className="relative flex items-center justify-between px-5 pt-6">
        <button onClick={() => nav(-1)} className="text-aura-textDim hover:text-white flex items-center gap-1"><ChevronLeft size={20} /></button>
      </header>
      <main className="relative mx-auto max-w-md px-4 pt-4 space-y-4">
        <div className="text-center pb-2">
          <div className="font-display font-black text-4xl aura-text-gradient">#{tag}</div>
          <div className="text-xs text-aura-textDim">{formatAura(items.length)} {t('feed.reactionsLabel').includes('Aura') ? 'posts' : 'publicaciones'}</div>
        </div>
        {loading ? (
          <div className="text-center py-16 text-aura-textDim animate-aura-pulse text-4xl">⚡</div>
        ) : items.length === 0 ? (
          <div className="aura-card p-8 text-center text-sm text-aura-textDim">{t('feed.empty')}</div>
        ) : items.map((p) => <PostCard key={p.post_id} post={p} />)}
      </main>
      <BottomNav />
    </div>
  );
}
